import React from 'react';

import { stickyContainerRecipe } from './StickyContainer.css';
import { getClassNames } from '../../util/css';

export type Position = 'top' | 'right' | 'bottom' | 'left';

interface StickyContainerProps {
  children: React.ReactNode;
  isSticky?: boolean;
  position?: Position;
}

export const StickyContainer = React.forwardRef<HTMLDivElement, StickyContainerProps>(
  ({ children, isSticky = true, position }, ref) => {
    const classNames = getClassNames(
      stickyContainerRecipe({
        isSticky,
        position,
      }),
    );

    return (
      <div className={classNames} ref={ref}>
        {children}
      </div>
    );
  },
);

StickyContainer.displayName = 'StickyContainer';
